import { memo } from 'react';

import Dashboard from './Dashboard.tsx';

export const DashboardContainer = () => {
  return <Dashboard />;
};

export default memo(DashboardContainer);
